import { ReactElement } from 'react';
import { EmptyTableInfo } from 'components/common/noTableContentInfo/NoTableContentInfo';
import { EmptyListReason } from 'components/common/noTableContentInfo/NoTableContentInfo';

/**
 * Constant noRowsOverlay component for simple cases with EmptyTableInfo
 * Used instead of inline arrow function to maintain stable reference
 */
export const SearchPhraseMismatchNoRowsOverlay = (): ReactElement => (
  <EmptyTableInfo emptyTableReason={EmptyListReason.SEARCHPHRASE_MISMATCH} />
);

